import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export default function BlogDetail() {
  const { slug } = useParams();
  const { settings } = useSite();
  const [b, setB] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { setB(null); api.get(`/blog/${slug}`).then((r) => setB(r.data)).catch(() => setNf(true)); }, [slug]);
  if (nf) return <PublicLayout><div className="pt-40 pb-20 text-center"><h1 className="font-display text-2xl font-bold">Post not found</h1><Link to="/blog" className="text-brand-emerald mt-4 inline-block">← Blog</Link></div></PublicLayout>;
  if (!b) return <PublicLayout><div className="pt-40 grid place-items-center"><div className="h-10 w-10 rounded-full border-2 border-brand-emerald border-t-transparent animate-spin" /></div></PublicLayout>;

  const article = {
    "@context": "https://schema.org", "@type": "Article", headline: b.title,
    description: b.excerpt, datePublished: b.created_at, author: { "@type": "Organization", name: b.author || settings.company_name },
    publisher: { "@type": "Organization", name: settings.company_name },
  };

  return (
    <PublicLayout>
      <Seo title={b.seo_title || b.title} description={b.meta_description || b.excerpt} image={b.featured_image} type="article"
        schema={[article, breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Blog", url: "/blog" }, { name: b.title, url: window.location.href }])]} />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 pt-28 pb-16">
        <nav className="flex items-center gap-1.5 text-xs text-slate-400 mb-5">
          <Link to="/" className="hover:text-brand-emerald">Home</Link><ChevronRight size={12} />
          <Link to="/blog" className="hover:text-brand-emerald">Blog</Link><ChevronRight size={12} /><span className="text-slate-300">{b.category}</span>
        </nav>
        <span className="eyebrow">{b.category}</span>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-3">{b.title}</h1>
        <div className="text-sm text-slate-500 mt-3">By {b.author} · {new Date(b.created_at).toLocaleDateString()}</div>
        {b.featured_image && <img src={b.featured_image} alt={b.title} className="w-full rounded-2xl mt-6" />}
        <div className="mt-8 text-slate-300 leading-relaxed text-lg whitespace-pre-line">{b.content}</div>
        {b.tags?.length > 0 && (
          <div className="mt-8 flex flex-wrap gap-2">{b.tags.map((t) => <span key={t} className="px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs text-slate-400">#{t}</span>)}</div>
        )}
      </article>
    </PublicLayout>
  );
}
